/* North Borders — vanilla interactions for standalone export */
(function () {
  "use strict";

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-nb-page-root]'));
  if (!roots.length) return;

  roots.forEach(function (pageRoot) {
    var $$ = function (sel, root) { return Array.prototype.slice.call((root || pageRoot).querySelectorAll(sel)); };

  // -------- Packs filter tabs
  (function () {
    var section = pageRoot.querySelector('[data-nb-packs]');
    if (!section) return;
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-nb-pack-filter]'));
    var cards   = Array.prototype.slice.call(section.querySelectorAll('[data-nb-pack-cat]'));
    if (!buttons.length || !cards.length) return;
    var grid = section.querySelector('.nb-product-grid');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-nb-pack-filter');
        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('nb-filter--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach(function (c) {
          c.classList.toggle('nb-pack-hidden', cat !== 'all' && c.getAttribute('data-nb-pack-cat') !== cat);
        });
        if (grid) grid.scrollLeft = 0;
      });
    });
    cards.sort(function (a, b) {
      return parseInt(a.getAttribute('data-nb-price'), 10) - parseInt(b.getAttribute('data-nb-price'), 10);
    });
    cards.forEach(function (c) { grid.appendChild(c); });
    grid.scrollLeft = 0;

    // Drag-to-scroll for hover-capable pointers (desktop narrow window).
    // Touch scrolling is handled natively; skip for coarse pointers.
    if (grid && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var isDown = false, startX = 0, startScroll = 0, moved = 0, didDrag = false, capturedId = -1;
      grid.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        isDown = true; moved = 0; didDrag = false;
        startX = e.clientX;
        startScroll = grid.scrollLeft;
        // Do NOT setPointerCapture here — it retargets the subsequent click
        // to the grid element, breaking anchor navigation on plain clicks.
      });
      grid.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!didDrag && moved > 4) {
          didDrag = true;
          grid.classList.add('is-dragging');
          try { grid.setPointerCapture(e.pointerId); capturedId = e.pointerId; } catch (err) {}
        }
        if (didDrag) grid.scrollLeft = startScroll - dx;
      });
      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        if (capturedId !== -1) {
          try { grid.releasePointerCapture(capturedId); } catch (err) {}
          capturedId = -1;
        }
        // Defer class removal so click on the card is still suppressed if we dragged.
        setTimeout(function () { grid.classList.remove('is-dragging'); }, 0);
      }
      grid.addEventListener('pointerup', endDrag);
      grid.addEventListener('pointercancel', endDrag);
      // Swallow click only if a real drag occurred (prevents accidental card-link navigation after a drag).
      grid.addEventListener('click', function (e) {
        if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
      }, true);
    }
  }());

  // -------- Countdown (matches Countdown.tsx: 18 days from load) --------
  var targetIso = pageRoot.getAttribute("data-nb-draw-closes-at");
  var parsedTarget = targetIso ? Date.parse(targetIso) : NaN;
  var TARGET = Number.isFinite(parsedTarget) ? parsedTarget : Date.now() + 18 * 24 * 60 * 60 * 1000;
  function pad(n) { return String(n).padStart(2, "0"); }
  function tickCountdown() {
    var diff = Math.max(0, TARGET - Date.now());
    var vals = [
      Math.floor(diff / 86400000),
      Math.floor((diff / 3600000) % 24),
      Math.floor((diff / 60000) % 60),
      Math.floor((diff / 1000) % 60)
    ];
    $$('[data-nb-countdown]').forEach(function (grid) {
      var nums = $$('[data-nb-countdown-value]', grid);
      nums.forEach(function (el, i) { if (vals[i] != null) el.textContent = pad(vals[i]); });
    });
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  // -------- Monthly / Yearly toggle + tier price updates --------
  $$(".nb-section--tiers").forEach(function (section) {
    var yearly = false;

    function applyYearly() {
      $$("[data-nb-billing-toggle]", section).forEach(function (btn) {
        var isYearlyBtn = /Yearly/.test(btn.textContent);
        var active = isYearlyBtn === yearly;
        btn.classList.toggle("nb-toggle__button--active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
      $$("[data-nb-tier-price]", section).forEach(function (el) {
        if (!el.dataset.basePrice) {
          el.dataset.basePrice = (el.textContent || "").replace(/[^0-9.]/g, "");
        }
        var base = parseFloat(el.dataset.basePrice) || 0;
        el.textContent = "$" + (yearly ? (base * 10).toFixed(2) : base.toFixed(2));
      });
      $$("[data-nb-tier-period]", section).forEach(function (el) {
        el.textContent = yearly ? "USD / yr" : "USD / mo";
      });
    }

    $$("[data-nb-billing-toggle]", section).forEach(function (btn) {
      btn.addEventListener("click", function () {
        yearly = /Yearly/.test(btn.textContent);
        applyYearly();
      });
    });
    applyYearly();
  });

  // -------- Proxy visible November membership toggles to the price-table snippet --------
  $$(".nb-section--tiers").forEach(function (section) {
    var proxyToggle = section.querySelector("[data-nb-price-proxy-toggle]");
    var snippetToggle = section.querySelector(".pricing-wrapper .pricing-toggle");
    if (!proxyToggle || !snippetToggle) return;

    var proxyButtons = $$("[data-nb-price-proxy-plan]", proxyToggle);

    function getActivePlan() {
      var activeReal = snippetToggle.querySelector(".toggle-option.active");
      if (activeReal && activeReal.getAttribute("data-plan")) {
        return activeReal.getAttribute("data-plan");
      }
      return snippetToggle.classList.contains("monthly") ? "monthly" : "yearly";
    }

    function syncProxy() {
      var activePlan = getActivePlan();
      proxyButtons.forEach(function (btn) {
        var active = btn.getAttribute("data-nb-price-proxy-plan") === activePlan;
        btn.classList.toggle("active", active);
        btn.classList.toggle("nb-toggle__button--active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    proxyButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var plan = btn.getAttribute("data-nb-price-proxy-plan");
        var realButton = snippetToggle.querySelector('.toggle-option[data-plan="' + plan + '"]');
        if (realButton) realButton.click();
        window.setTimeout(syncProxy, 0);
      });
    });

    syncProxy();
    document.addEventListener("DOMContentLoaded", function () {
      window.setTimeout(syncProxy, 0);
    }, { once: true });
  });

  // -------- One-off vs membership maths chart --------
  (function () {
    var chartSection = pageRoot.querySelector("#nb-chart");
    if (!chartSection) return;

    var ONE_OFF = 75;
    var tier = "two";
    var tiers = {
      one: { start: 10, rate: 2 },
      two: { start: 30, rate: 10 }
    };

    var slider = chartSection.querySelector("[data-nb-math-month]");
    var monthValue = chartSection.querySelector("[data-nb-math-month-value]");
    var currentEl = chartSection.querySelector("[data-nb-math-current]");
    var totalEl = chartSection.querySelector("[data-nb-math-total]");
    var oneOffEl = chartSection.querySelector("[data-nb-math-oneoff]");
    var multipleEl = chartSection.querySelector("[data-nb-math-multiple]");
    var chartSvg = chartSection.querySelector("[data-nb-math-chart]");
    var totalLabel = chartSection.querySelectorAll(".nb-stat-card__label")[1];

    function entriesAt(config, month) {
      return config.start + config.rate * (month - 1);
    }

    function totalBy(config, month) {
      return Math.round((month / 2) * (2 * config.start + (month - 1) * config.rate));
    }

    function drawChart(month, config) {
      if (!chartSvg) return;
      var width = 720;
      var height = 230;
      var left = 12;
      var right = 12;
      var top = 30;
      var bottom = 30;
      var plotH = height - top - bottom;
      var plotW = width - left - right;
      var max = Math.max(ONE_OFF, entriesAt(config, 12));
      var slot = plotW / 12;
      var barW = slot * 0.88;
      var lineY = top + plotH - (ONE_OFF / max) * plotH;
      var oneOffLabelY = Math.max(12, lineY - 8);
      var html =
        '<line x1="' + left + '" x2="' + (width - right) + '" y1="' + lineY + '" y2="' + lineY + '" stroke="#5C626B" stroke-dasharray="4 4" stroke-width="1"></line>' +
        '<text class="nb-chart-label" x="' + left + '" y="' + oneOffLabelY + '" text-anchor="start" fill="#AEB5BF" font-size="9" font-family="JetBrains Mono">ONE-OFF · ' + ONE_OFF + "</text>";

      for (var i = 1; i <= 12; i += 1) {
        var val = entriesAt(config, i);
        var barH = Math.max(2, (val / max) * plotH);
        var x = left + (i - 1) * slot + (slot - barW) / 2;
        var y = top + plotH - barH;
        var active = i === month;
        html +=
          '<g>' +
          '<rect x="' + x + '" y="' + y + '" width="' + barW + '" height="' + barH + '" fill="#FFB020" opacity="' + (0.45 + i / 24).toFixed(3) + '" rx="2"></rect>' +
          (active ? '<rect x="' + (x - 1) + '" y="' + (y - 1) + '" width="' + (barW + 2) + '" height="' + (barH + 2) + '" fill="none" stroke="#F4F5F7" stroke-width="1.2" rx="2"></rect><text x="' + (x + barW / 2) + '" y="' + (y - 6) + '" text-anchor="middle" fill="#F4F5F7" font-size="11" font-family="JetBrains Mono" font-weight="700">' + val + "</text>" : "") +
          '<text class="nb-chart-label" x="' + (x + barW / 2) + '" y="220" text-anchor="middle" fill="#868C96" font-size="9" font-family="JetBrains Mono">' + String(i).padStart(2, "0") + "</text>" +
          '<rect class="nb-chart-hit-area" data-nb-chart-month="' + i + '" x="' + (left + (i - 1) * slot) + '" y="' + top + '" width="' + slot + '" height="' + plotH + '" fill="transparent"></rect>' +
          "</g>";
      }
      chartSvg.innerHTML = html;
      $$("[data-nb-chart-month]", chartSvg).forEach(function (hit) {
        hit.addEventListener("click", function () {
          if (!slider) return;
          slider.value = hit.getAttribute("data-nb-chart-month");
          draw();
        });
      });
    }

    function draw() {
      var month = Math.max(1, Math.min(12, parseInt(slider && slider.value, 10) || 12));
      var config = tiers[tier] || tiers.two;
      var current = entriesAt(config, month);
      var total = totalBy(config, month);

      if (slider) slider.value = month;
      if (monthValue) monthValue.textContent = month;
      if (currentEl) currentEl.textContent = current.toLocaleString();
      if (totalEl) totalEl.textContent = total.toLocaleString();
      if (oneOffEl) oneOffEl.textContent = ONE_OFF.toLocaleString();
      if (multipleEl) multipleEl.textContent = (total / ONE_OFF).toFixed(1) + "× more";
      if (totalLabel) totalLabel.textContent = "Total by month " + month;
      drawChart(month, config);
    }

    $$("[data-nb-math-tier]", chartSection).forEach(function (btn) {
      btn.addEventListener("click", function () {
        tier = btn.getAttribute("data-nb-math-tier") || "two";
        $$("[data-nb-math-tier]", chartSection).forEach(function (other) {
          var active = other === btn;
          other.classList.toggle("nb-toggle__button--active", active);
          other.setAttribute("aria-pressed", active ? "true" : "false");
        });
        draw();
      });
    });

    if (slider) slider.addEventListener("input", draw);
    window.addEventListener("resize", draw, { passive: true });
    draw();
  })();


  // -------- Floating Enter Now button: show after hero leaves viewport --------
  (function () {
    var fab = pageRoot.querySelector("[data-nb-fab]");
    var hero = pageRoot.querySelector(".nb-hero");
    if (!fab || !hero || !("IntersectionObserver" in window)) {
      if (fab) fab.classList.add("is-visible");
      return;
    }
    var fabObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        fab.classList.toggle("is-visible", !entry.isIntersecting);
      });
    }, { threshold: 0 });
    fabObserver.observe(hero);
  })();

  // -------- Prize card "Full specs" disclosure toggle (S3, both breakpoints) --------
  (function () {
    var toggles = $$('.nb-prize-disclosure__toggle');
    if (!toggles.length) return;
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }());

  // -------- Prize tabs (mobile-only): swap between 1st / 2nd / 3rd panels --------
  (function () {
    var tabs = $$('[data-nb-prize-tab]');
    var panels = $$('[data-nb-prize-panel]');
    if (!tabs.length || !panels.length) return;
    function select(i) {
      tabs.forEach(function (t, j) {
        var active = i === j;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.classList.toggle('nb-prize-tab--active', active);
        if (active) { t.removeAttribute('tabindex'); } else { t.setAttribute('tabindex', '-1'); }
      });
      panels.forEach(function (p, j) {
        if (i === j) { p.setAttribute('data-nb-prize-active', ''); }
        else { p.removeAttribute('data-nb-prize-active'); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        select(next);
        tabs[next].focus();
      });
    });
  }());

  // -------- Membership tier cards: mobile disclosure (scoped to this page) --------
  (function () {
    var cards = $$('.nb-membership-price-table .nb-tier-card');
    if (!cards.length) return;
    cards.forEach(function (card) {
      if (card.querySelector('.nb-tier-toggle')) return;
      var body = card.querySelector('.nb-tier-card__body');
      var cta = card.querySelector('a[class*="join-tier"]');
      if (!body || !cta) return;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'nb-tier-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Show benefits';
      toggle.addEventListener('click', function () {
        var open = card.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? 'Hide benefits' : 'Show benefits';
      });
      cta.parentNode.insertBefore(toggle, cta);
    });
  }());

  // -------- Smooth scroll for in-page anchor links --------
  $$('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").slice(1);
      if (!id) return;
      var el = pageRoot.querySelector("#" + id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  // -------- Hero video: click to toggle play/pause --------
  var heroReel = pageRoot.querySelector(".nb-hero-reel");
  var heroVideo = pageRoot.querySelector("[data-nb-hero-video]");
  var heroPlayButton = pageRoot.querySelector("[data-nb-hero-play]");

  if (heroPlayButton && heroVideo) {
    var heroPlayIconHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>';
    var heroPauseIconHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>';

    var syncHeroButton = function () {
      if (heroVideo.paused) {
        heroPlayButton.innerHTML = heroPlayIconHTML;
        heroPlayButton.setAttribute("aria-label", "Play video");
        heroPlayButton.classList.remove("is-playing");
      } else {
        heroPlayButton.innerHTML = heroPauseIconHTML;
        heroPlayButton.setAttribute("aria-label", "Pause video");
        heroPlayButton.classList.add("is-playing");
      }
    };

    var isMobileViewport = function () {
      return window.matchMedia && window.matchMedia("(max-width: 47.9375rem)").matches;
    };

    var attachTapCatcher = function () {
      if (!heroReel) return;
      if (heroReel.querySelector(".nb-hero-reel__tap-catch")) return;
      var catcher = document.createElement("div");
      catcher.className = "nb-hero-reel__tap-catch";
      catcher.setAttribute("aria-hidden", "true");
      catcher.addEventListener("click", function (event) {
        event.stopPropagation();
        if (heroVideo.paused) startHeroPlayback();
        else heroVideo.pause();
      });
      heroReel.appendChild(catcher);
    };

    var enableNativeControls = function () {
      if (heroVideo.hasAttribute("controls")) return;
      heroVideo.setAttribute("controls", "");
      heroVideo.setAttribute("controlslist", "nodownload");
      if (heroReel) heroReel.classList.add("has-native-controls");
      attachTapCatcher();
    };

    var startHeroPlayback = function () {
      heroVideo.muted = false;
      heroVideo.volume = 1;
      heroVideo.play && heroVideo.play().catch(function () {});
    };

    var toggleHeroVideo = function () {
      if (!heroVideo.paused) {
        heroVideo.pause();
        return;
      }
      var shouldWaitForExpand =
        heroReel &&
        isMobileViewport() &&
        !heroReel.classList.contains("is-expanded") &&
        !heroReel.classList.contains("has-native-controls");

      if (!shouldWaitForExpand) {
        enableNativeControls();
        startHeroPlayback();
        return;
      }

      if (heroVideo.preload === "none") heroVideo.preload = "metadata";
      var handled = false;
      var finish = function () {
        if (handled) return;
        handled = true;
        heroReel.removeEventListener("transitionend", onEnd);
        enableNativeControls();
        startHeroPlayback();
      };
      var onEnd = function (e) {
        if (e && e.propertyName && e.propertyName !== "aspect-ratio") return;
        finish();
      };
      heroReel.addEventListener("transitionend", onEnd);
      setTimeout(finish, 500);
      heroReel.classList.add("is-expanded");
    };

    heroPlayButton.addEventListener("click", function (event) {
      event.stopPropagation();
      toggleHeroVideo();
    });
    if (heroReel) {
      heroReel.addEventListener("click", function (event) {
        if (heroVideo.hasAttribute("controls")) return;
        if (event.target === heroVideo) return;
        toggleHeroVideo();
      });
    }
    heroVideo.addEventListener("play", syncHeroButton);
    heroVideo.addEventListener("pause", syncHeroButton);
    heroVideo.addEventListener("ended", syncHeroButton);
  }

  // -------- Prize card → entry-options modal (S2)
  (function () {
    var section = pageRoot.querySelector('#nb-prizes');
    var modal = pageRoot.querySelector('[data-nb-prize-modal]');
    if (!section || !modal) return;
    var titleEl = modal.querySelector('[data-nb-prize-modal-title]');
    var subEl = modal.querySelector('[data-nb-prize-modal-sub]');
    var instantAction = modal.querySelector('[data-nb-prize-action="instant"]');
    var defaultSub = subEl ? subEl.textContent : '';
    var membersOnlySub = 'Members only. Join any tier to enter this draw.';
    var lastFocused = null;

    function openModal(prizeName, membersOnly) {
      if (titleEl) {
        titleEl.textContent = prizeName ? 'Enter to win: ' + prizeName : "This month's draw";
      }
      if (subEl) subEl.textContent = membersOnly ? membersOnlySub : defaultSub;
      if (instantAction) instantAction.hidden = !!membersOnly;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nb-prize-modal-open');
      lastFocused = document.activeElement;
      var closeBtn = modal.querySelector('.nb-prize-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nb-prize-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    section.addEventListener('click', function (e) {
      var card = e.target.closest('.nb-prize-card');
      if (!card || !section.contains(card)) return;
      if (e.target.closest('button, a, [data-nb-prize-disclosure], .nb-prize-modal')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      var titleNode = card.querySelector('.nb-prize-card__title');
      var panelIdx = card.getAttribute('data-nb-prize-panel');
      var membersOnly = panelIdx !== '0';
      openModal(titleNode ? titleNode.textContent.trim() : null, membersOnly);
    });

    modal.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-nb-prize-close]');
      if (!closer) return;
      if (closer.tagName === 'A') {
        closeModal();
      } else {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }());

  (function initJumpNav() {
    var nav = document.querySelector('[data-nb-jumpnav]');
    if (!nav) return;
    var threshold = function () { return Math.round(window.innerHeight * 1.5); };
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > threshold()) {
        nav.setAttribute('data-visible', '');
      } else {
        nav.removeAttribute('data-visible');
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }());

  (function initPacksHint() {
    if (!window.matchMedia('(max-width: 47.9375rem)').matches) return;
    var section = pageRoot.querySelector('.nb-packs--slider');
    if (!section) return;
    var rail = section.querySelector('.nb-product-grid');
    if (!rail || !rail.parentNode) return;

    var wrap = document.createElement('div');
    wrap.className = 'nb-packs__rail-wrap';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);

    var hint = document.createElement('div');
    hint.className = 'nb-packs__hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"></polyline></svg>';
    wrap.appendChild(hint);

    var swiped = false;
    var armScrollBase = 0;

    function play() {
      if (swiped) return;
      hint.classList.remove('is-playing');
      // force reflow so the animation restarts on re-entry
      void hint.offsetWidth;
      hint.classList.add('is-playing');
    }
    function stopForever() {
      if (swiped) return;
      swiped = true;
      hint.classList.remove('is-playing');
      if (hint.parentNode) hint.parentNode.removeChild(hint);
      rail.removeEventListener('scroll', onRailScroll);
      rail.removeEventListener('touchmove', stopForever);
    }
    function onRailScroll() {
      if (Math.abs(rail.scrollLeft - armScrollBase) > 8) stopForever();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            armScrollBase = rail.scrollLeft;
            play();
          }
        });
      }, { threshold: 0.35 });
      io.observe(wrap);
    } else {
      play();
    }

    rail.addEventListener('scroll', onRailScroll, { passive: true });
    rail.addEventListener('touchmove', stopForever, { passive: true });
  }());
  });
})();
